<template>
    <div class="table-responsive">
        <table class="table-bordered table">
            <colgroup>
                <template v-for="(col, i) in CONFIG_TABLE_TAB_11().headers">
                    <col v-for="n in col.colspan || 1" :key="i + '-' + n" :style="{ width: col.width }" />
                </template>
            </colgroup>
            <tbody>
                <tr>
                    <th :colspan="lengthHeaders">＜抽選条件＞※応募割れの場合は抽選条件が変わる可能性があります。</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_11(dataObject.prizes, isPreview)['賞品']">
                    <tr>
                        <template v-for="(objHeader, idx) in CONFIG_TABLE_TAB_11().headers">
                            <th
                                v-if="idx == 0"
                                :key="`header-first-${idx}`"
                                :rowspan="dataObject.prizes.data.length + 1"
                                :class="objHeader.bgClass"
                                style="padding-left: 3px"
                            >
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_11(dataObject.prizes)['賞品']"
                                        @change="toggleCommonSwitch($event, dataObject.prizes.data)"
                                    />
                                    <div>{{ objHeader.label }}</div>
                                </div>
                            </th>
                            <th v-else :key="`header-sub-${idx}`" :class="objHeader.bgClass" :colspan="objHeader.colspan">{{ objHeader.label }}</th>
                        </template>
                    </tr>
                    <tr v-for="(item, k) in dataObject.prizes.data" :key="item.name">
                        <td class="bg-color5">{{ item.name }}</td>
                        <td>
                            <InputText
                                :model.sync="dataObject.prizes.data[k].number_of_win_prize"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject.prizes)['賞品']"
                                :config="inputConfig.num"
                                @change="
                                    (val) => {
                                        if (!val?.length) dataObject.prizes.data[k].number_of_win_prize = '0';
                                    }
                                "
                            />
                        </td>
                        <td>
                            <InputText
                                :model.sync="dataObject.prizes.data[k].preliminary_winner"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject.prizes)['賞品']"
                                :config="inputConfig.num"
                                @change="
                                    (val) => {
                                        if (!val?.length) dataObject.prizes.data[k].preliminary_winner = '0';
                                    }
                                "
                            />
                        </td>
                        <td>
                            <TextareaComponent
                                :id="'tab11-textarea-prizes-' + k"
                                :model.sync="item.write_freely"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject.prizes)['賞品']"
                                :config="inputConfig.write_freely"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <div
                                :class="`d-flex align-items-center justify-content-center box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject.prizes)['賞品'] ? 'disabled_input' : ''}`"
                                :style="{
                                    'background-color':
                                        isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject.prizes)['賞品'] ? '' : '#ffffff'
                                }"
                            >
                                {{ item.total_winner }}
                            </div>
                        </td>
                        <td v-if="k == 0" :rowspan="dataObject.prizes.data.length" align="middle">
                            <div
                                :class="`d-flex align-items-center justify-content-center box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject.prizes)['賞品'] ? 'disabled_input' : ''}`"
                                :style="{
                                    'background-color':
                                        isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject.prizes)['賞品'] ? '' : '#ffffff'
                                }"
                            >
                                {{ dataObject.prizes.sum_total_winner }}
                            </div>
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields['prizes_' + k + '_first'])"
                                v-model="item.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('prizes', 'first', k)"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields['prizes_' + k + '_secondary'])"
                                v-model="item.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('prizes', 'secondary', k)"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['抽選方法']">
                    <tr>
                        <td colspan="2" rowspan="2" class="bg-color5">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['抽選方法']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            lottery_method: dataObject.lottery_method,
                                            lottery_method_detail: dataObject.lottery_method_detail
                                        })
                                    "
                                />
                                抽選方法
                            </div>
                        </td>
                        <td colspan="5">
                            <div
                                :class="`box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['抽選方法'] ? 'disabled_input' : ''}`"
                                :style="{
                                    'background-color':
                                        isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['抽選方法'] ? '' : '#ffffff',
                                    'min-height': '37px'
                                }"
                            >
                                {{ dataObject.lottery_method.data }}
                            </div>
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.lottery_method_first)"
                                v-model="dataObject.lottery_method.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('lottery_method', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.lottery_method_secondary)"
                                v-model="dataObject.lottery_method.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('lottery_method', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab11-textarea-1"
                                :model.sync="dataObject.lottery_method_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['抽選方法']"
                                :config="inputConfig.lottery_method_detail"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.lottery_method_detail_first)"
                                v-model="dataObject.lottery_method_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('lottery_method_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.lottery_method_detail_secondary)"
                                v-model="dataObject.lottery_method_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('lottery_method_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['ダウンロード']">
                    <tr>
                        <td
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_11(dataObject, isPreview), CONFIG_ROWSPAN_TAB_11['ダウンロード'])"
                            class="bg-color5"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['ダウンロード']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            campaign_id_record: dataObject.campaign_id_record,
                                            campaign_title: dataObject.campaign_title
                                        })
                                    "
                                />
                                ダウンロード
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['キャンペーンID']">
                            <td class="bg-color5">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_11(dataObject)['キャンペーンID']"
                                        :disabled="!SWITCH_FIELD_TAB_11(dataObject)['ダウンロード']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                campaign_id_record: dataObject.campaign_id_record
                                            })
                                        "
                                    />
                                    キャンペーンID
                                </div>
                            </td>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab11-textarea-2"
                                    :model.sync="dataObject.campaign_id_record.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['キャンペーンID']"
                                    :config="inputConfig.campaign_id_record"
                                    :isPreview="isPreview"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.campaign_id_record_first)"
                                    v-model="dataObject.campaign_id_record.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('campaign_id_record', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.campaign_id_record_secondary)"
                                    v-model="dataObject.campaign_id_record.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('campaign_id_record', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['キャンペーンタイトル']">
                        <td class="bg-color5">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['キャンペーンタイトル']"
                                    :disabled="!SWITCH_FIELD_TAB_11(dataObject)['ダウンロード']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            campaign_title: dataObject.campaign_title
                                        })
                                    "
                                />
                                キャンペーンタイトル
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab11-textarea-3"
                                :model.sync="dataObject.campaign_title.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['キャンペーンタイトル']"
                                :config="inputConfig.campaign_title"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.campaign_title_first)"
                                v-model="dataObject.campaign_title.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('campaign_title', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.campaign_title_secondary)"
                                v-model="dataObject.campaign_title.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('campaign_title', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['応募有効期間']">
                    <td colspan="2" class="bg-color5">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_11(dataObject)['応募有効期間']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        application_validity_period: dataObject.application_validity_period
                                    })
                                "
                            />
                            応募有効期間
                        </div>
                    </td>
                    <td colspan="5">
                        <div
                            :class="`box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['応募有効期間'] ? 'disabled_input' : ''}`"
                            :style="{
                                'background-color':
                                    isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['応募有効期間'] ? '' : '#ffffff',
                                'min-height': '37px'
                            }"
                        >
                            {{ formatDateTimeJapanese(detailBeginForDocument.campaign_start_date) }}～{{
                                formatDateTimeJapanese(detailBeginForDocument.campaign_end_date)
                            }}
                        </div>
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.application_validity_period_first)"
                            v-model="dataObject.application_validity_period.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('application_validity_period', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.application_validity_period_secondary)"
                            v-model="dataObject.application_validity_period.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('application_validity_period', 'secondary')"
                        />
                    </td>
                </tr>

                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['重複条件']">
                    <tr>
                        <td
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_11(dataObject, isPreview), CONFIG_ROWSPAN_TAB_11['重複条件'])"
                            class="bg-color5"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['重複条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            prize_winning: dataObject.prize_winning,
                                            cross_application_form: dataObject.cross_application_form
                                        })
                                    "
                                />
                                重複条件
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['賞品またぎ']">
                            <td class="bg-color5">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_11(dataObject)['賞品またぎ']"
                                        :disabled="!SWITCH_FIELD_TAB_11(dataObject)['重複条件']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                prize_winning: dataObject.prize_winning
                                            })
                                        "
                                    />
                                    賞品またぎ
                                </div>
                            </td>
                            <td colspan="5">
                                <CommonMultiselect
                                    v-model="dataObject.prize_winning.data"
                                    :options.sync="option.prize_winning"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['賞品またぎ']"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.prize_winning_first)"
                                    v-model="dataObject.prize_winning.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('prize_winning', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.prize_winning_secondary)"
                                    v-model="dataObject.prize_winning.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('prize_winning', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['応募形態またぎ']">
                        <td class="bg-color5">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['応募形態またぎ']"
                                    :disabled="!SWITCH_FIELD_TAB_11(dataObject)['重複条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            cross_application_form: dataObject.cross_application_form
                                        })
                                    "
                                />
                                応募形態またぎ
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.cross_application_form.data"
                                :options.sync="option.cross_application_form"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['応募形態またぎ']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.cross_application_form_first)"
                                v-model="dataObject.cross_application_form.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('cross_application_form', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.cross_application_form_secondary)"
                                v-model="dataObject.cross_application_form.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('cross_application_form', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['比率指定']">
                    <tr>
                        <td colspan="2" rowspan="2" class="bg-color5">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['比率指定']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            ratio_specification: dataObject.ratio_specification,
                                            ratio_specification_detail: dataObject.ratio_specification_detail
                                        })
                                    "
                                />
                                比率指定
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.ratio_specification.data"
                                :options.sync="option.ratio_specification"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['比率指定']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_first)"
                                v-model="dataObject.ratio_specification.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_secondary)"
                                v-model="dataObject.ratio_specification.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab11-textarea-4"
                                :model.sync="dataObject.ratio_specification_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['比率指定']"
                                :config="inputConfig.ratio_specification_detail"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_detail_first)"
                                v-model="dataObject.ratio_specification_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.ratio_specification_detail_secondary)"
                                v-model="dataObject.ratio_specification_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('ratio_specification_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['その他条件']">
                    <tr>
                        <td colspan="2" class="bg-color5" rowspan="2">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['その他条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            other_conditions: dataObject.other_conditions,
                                            other_condition_detail: dataObject.other_condition_detail
                                        })
                                    "
                                />
                                その他条件
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.other_conditions.data"
                                :options.sync="option.other_conditions"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['その他条件']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_conditions_first)"
                                v-model="dataObject.other_conditions.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_conditions', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_conditions_secondary)"
                                v-model="dataObject.other_conditions.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_conditions', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab11-textarea-5"
                                :model.sync="dataObject.other_condition_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['その他条件']"
                                :config="inputConfig.other_condition_detail"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_condition_detail_first)"
                                v-model="dataObject.other_condition_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_condition_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_condition_detail_secondary)"
                                v-model="dataObject.other_condition_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_condition_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['＜抽選条件＞その他先_11']">
                    <td class="bg-color5" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_11(dataObject)['＜抽選条件＞その他先_11']"
                            @change="toggleCommonSwitch($event, { free_block_lottery_condition: dataObject.free_block_lottery_condition })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_lottery_condition.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜抽選条件＞その他先_11']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜抽選条件＞その他先_11'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_lottery_condition.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-＜抽選条件＞その他先_11-${idTab}`"
                            :model.sync="dataObject.free_block_lottery_condition.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜抽選条件＞その他先_11'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th :colspan="lengthHeaders">＜重複チェック＞</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['同一世帯']">
                    <tr>
                        <td
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_11(dataObject, isPreview), CONFIG_ROWSPAN_TAB_11['同一世帯'])"
                            class="bg-color6"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['同一世帯']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            same_household_1: dataObject.same_household_1,
                                            same_household_2: dataObject.same_household_2,
                                            same_household_type: dataObject.same_household_type
                                        })
                                    "
                                />
                                同一世帯
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['確認項目_同一世帯_11']">
                            <td class="bg-color6">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_11(dataObject)['確認項目_同一世帯_11']"
                                        :disabled="!SWITCH_FIELD_TAB_11(dataObject)['同一世帯']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                same_household_type: dataObject.same_household_type,
                                                same_household_1: dataObject.same_household_1
                                            })
                                        "
                                    />
                                    確認項目
                                </div>
                            </td>
                            <td rowspan="1" colspan="2">
                                <CommonMultiselect
                                    v-model="dataObject.same_household_type"
                                    :options.sync="option.same_household_type"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['確認項目_同一世帯_11']"
                                />
                            </td>
                            <td colspan="3">
                                <CommonMultiselect
                                    v-model="dataObject.same_household_1.data"
                                    :options.sync="option.same_household_1"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['確認項目_同一世帯_11']"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_household_1_first)"
                                    v-model="dataObject.same_household_1.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('same_household_1', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_household_1_secondary)"
                                    v-model="dataObject.same_household_1.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('same_household_1', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['確認条件']">
                        <td class="bg-color6">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['確認条件']"
                                    :disabled="!SWITCH_FIELD_TAB_11(dataObject)['同一世帯']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            same_household_2: dataObject.same_household_2
                                        })
                                    "
                                />
                                確認条件
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.same_household_2.data"
                                :options.sync="option.same_household_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['確認条件']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_household_2_first)"
                                v-model="dataObject.same_household_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('same_household_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_household_2_secondary)"
                                v-model="dataObject.same_household_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('same_household_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['同一人物']">
                    <tr>
                        <td
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_11(dataObject, isPreview), CONFIG_ROWSPAN_TAB_11['同一人物'])"
                            class="bg-color6"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['同一人物']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            same_person_1: dataObject.same_person_1,
                                            same_person_2: dataObject.same_person_2,
                                            same_person_type: dataObject.same_person_type
                                        })
                                    "
                                />
                                同一人物
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['確認項目_同一人物_11']">
                            <td class="bg-color6">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_11(dataObject)['確認項目_同一人物_11']"
                                        :disabled="!SWITCH_FIELD_TAB_11(dataObject)['同一人物']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                same_person_type: dataObject.same_person_type,
                                                same_person_1: dataObject.same_person_1
                                            })
                                        "
                                    />
                                    確認項目
                                </div>
                            </td>
                            <td rowspan="1" colspan="2">
                                <CommonMultiselect
                                    v-model="dataObject.same_person_type"
                                    :options.sync="option.same_person_type"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['確認項目_同一人物_11']"
                                />
                            </td>
                            <td colspan="3">
                                <CommonMultiselect
                                    v-model="dataObject.same_person_1.data"
                                    :options.sync="option.same_person_1"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['確認項目_同一人物_11']"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_person_1_first)"
                                    v-model="dataObject.same_person_1.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('same_person_1', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_person_1_secondary)"
                                    v-model="dataObject.same_person_1.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('same_person_1', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['確認条件_同一人物_11']">
                        <td class="bg-color6">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['確認条件_同一人物_11']"
                                    :disabled="!SWITCH_FIELD_TAB_11(dataObject)['同一人物']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            same_person_2: dataObject.same_person_2
                                        })
                                    "
                                />
                                確認条件
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.same_person_2.data"
                                :options.sync="option.same_person_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['確認条件_同一人物_11']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_person_2_first)"
                                v-model="dataObject.same_person_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('same_person_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.same_person_2_secondary)"
                                v-model="dataObject.same_person_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('same_person_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['＜重複チェック＞その他']">
                    <tr>
                        <td
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_11(dataObject, isPreview), CONFIG_ROWSPAN_TAB_11['＜重複チェック＞その他'])"
                            class="bg-color6"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['＜重複チェック＞その他']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            others_duplicate_1: dataObject.others_duplicate_1,
                                            others_duplicate_2: dataObject.others_duplicate_2,
                                            others_duplicate: dataObject.others_duplicate
                                        })
                                    "
                                />
                                その他
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['確認項目_＜重複チェック＞その他_11']">
                            <td class="bg-color6">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_11(dataObject)['確認項目_＜重複チェック＞その他_11']"
                                        :disabled="!SWITCH_FIELD_TAB_11(dataObject)['＜重複チェック＞その他']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                others_duplicate: dataObject.others_duplicate,
                                                others_duplicate_1: dataObject.others_duplicate_1
                                            })
                                        "
                                    />
                                    確認項目
                                </div>
                            </td>
                            <td rowspan="1" colspan="2">
                                <CommonMultiselect
                                    v-model="dataObject.others_duplicate"
                                    :options.sync="option.others_duplicate"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['確認項目_＜重複チェック＞その他_11']"
                                />
                            </td>
                            <td colspan="3">
                                <TextareaComponent
                                    id="tab11-textarea-6"
                                    :model.sync="dataObject.others_duplicate_1.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['確認項目_＜重複チェック＞その他_11']"
                                    :config="inputConfig.others_duplicate_1"
                                    :isPreview="isPreview"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_duplicate_1_first)"
                                    v-model="dataObject.others_duplicate_1.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('others_duplicate_1', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_duplicate_1_secondary)"
                                    v-model="dataObject.others_duplicate_1.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('others_duplicate_1', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['確認条件_＜重複チェック＞その他_11']">
                        <td class="bg-color6">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['確認条件_＜重複チェック＞その他_11']"
                                    :disabled="!SWITCH_FIELD_TAB_11(dataObject)['＜重複チェック＞その他']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            others_duplicate_2: dataObject.others_duplicate_2
                                        })
                                    "
                                />
                                確認条件
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.others_duplicate_2.data"
                                :options.sync="option.others_duplicate_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['確認条件_＜重複チェック＞その他_11']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_duplicate_2_first)"
                                v-model="dataObject.others_duplicate_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('others_duplicate_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_duplicate_2_secondary)"
                                v-model="dataObject.others_duplicate_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('others_duplicate_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['＜重複チェック＞その他先_11']">
                    <td class="bg-color6" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_11(dataObject)['＜重複チェック＞その他先_11']"
                            @change="toggleCommonSwitch($event, { free_block_duplicate_check: dataObject.free_block_duplicate_check })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_duplicate_check.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜重複チェック＞その他先_11']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜重複チェック＞その他先_11'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_duplicate_check.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-＜重複チェック＞その他先_11-${idTab}`"
                            :model.sync="dataObject.free_block_duplicate_check.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜重複チェック＞その他先_11'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th :colspan="lengthHeaders">＜不備チェック＞</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['名前不備確認']">
                    <td colspan="2" class="bg-color6">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_11(dataObject)['名前不備確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_error_name: dataObject.confirm_error_name
                                    })
                                "
                            />
                            名前不備確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab11-textarea-7"
                            :model.sync="dataObject.confirm_error_name.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['名前不備確認']"
                            :config="inputConfig.confirm_error_name"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_error_name_first)"
                            v-model="dataObject.confirm_error_name.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_error_name', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_error_name_secondary)"
                            v-model="dataObject.confirm_error_name.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_error_name', 'secondary')"
                        />
                    </td>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['住所不備確認']">
                    <tr>
                        <td colspan="2" class="bg-color6" rowspan="2">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['住所不備確認']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            address_verification_1: dataObject.address_verification_1,
                                            address_verification_2: dataObject.address_verification_2
                                        })
                                    "
                                />
                                住所不備確認
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab11-textarea-8"
                                :model.sync="dataObject.address_verification_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['住所不備確認']"
                                :config="inputConfig.address_verification_1"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_1_first)"
                                v-model="dataObject.address_verification_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_1_secondary)"
                                v-model="dataObject.address_verification_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.address_verification_2.data"
                                :options.sync="option.address_verification_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['住所不備確認']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_2_first)"
                                v-model="dataObject.address_verification_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_2_secondary)"
                                v-model="dataObject.address_verification_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['電話番号不備確認']">
                    <td class="bg-color6" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_11(dataObject)['電話番号不備確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_phone_number_is_incomplete: dataObject.confirm_phone_number_is_incomplete
                                    })
                                "
                            />
                            電話番号不備確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab11-textarea-9"
                            :model.sync="dataObject.confirm_phone_number_is_incomplete.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['電話番号不備確認']"
                            :config="inputConfig.confirm_phone_number_is_incomplete"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_phone_number_is_incomplete_first)"
                            v-model="dataObject.confirm_phone_number_is_incomplete.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_phone_number_is_incomplete', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_phone_number_is_incomplete_secondary)"
                            v-model="dataObject.confirm_phone_number_is_incomplete.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_phone_number_is_incomplete', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['メールアドレス不備確認']">
                    <td class="bg-color6" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_11(dataObject)['メールアドレス不備確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_email_address_is_incomplete: dataObject.confirm_email_address_is_incomplete
                                    })
                                "
                            />
                            メールアドレス不備確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab11-textarea-10"
                            :model.sync="dataObject.confirm_email_address_is_incomplete.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['メールアドレス不備確認']"
                            :config="inputConfig.confirm_email_address_is_incomplete"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_email_address_is_incomplete_first)"
                            v-model="dataObject.confirm_email_address_is_incomplete.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_email_address_is_incomplete', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_email_address_is_incomplete_secondary)"
                            v-model="dataObject.confirm_email_address_is_incomplete.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_email_address_is_incomplete', 'secondary')"
                        />
                    </td>
                </tr>

                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['＜不備チェック＞その他']">
                    <tr>
                        <td class="bg-color6" colspan="2" rowspan="2">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['＜不備チェック＞その他']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            other_errors: dataObject.other_errors,
                                            other_error_detail: dataObject.other_error_detail
                                        })
                                    "
                                />
                                その他
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.other_errors.data"
                                :options.sync="option.other_errors"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜不備チェック＞その他']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_errors_first)"
                                v-model="dataObject.other_errors.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_errors', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_errors_secondary)"
                                v-model="dataObject.other_errors.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_errors', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab11-textarea-11"
                                :model.sync="dataObject.other_error_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜不備チェック＞その他']"
                                :config="inputConfig.other_error_detail"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_error_detail_first)"
                                v-model="dataObject.other_error_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_error_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_error_detail_secondary)"
                                v-model="dataObject.other_error_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_error_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['＜不備チェック＞その他先_11']">
                    <td class="bg-color6" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_11(dataObject)['＜不備チェック＞その他先_11']"
                            @change="toggleCommonSwitch($event, { free_block_deficiency_check: dataObject.free_block_deficiency_check })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_deficiency_check.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜不備チェック＞その他先_11']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜不備チェック＞その他先_11'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_deficiency_check.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-＜不備チェック＞その他先_11-${idTab}`"
                            :model.sync="dataObject.free_block_deficiency_check.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜不備チェック＞その他先_11'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th :colspan="lengthHeaders">＜購買チェック＞</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['購入有効期間']">
                    <td colspan="2" class="bg-color6">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_11(dataObject)['購入有効期間']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        purchase_validity_period: dataObject.purchase_validity_period
                                    })
                                "
                            />
                            購入有効期間
                        </div>
                    </td>
                    <td colspan="5">
                        <div
                            :class="`box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['購入有効期間'] ? 'disabled_input' : ''}`"
                            :style="{
                                'background-color':
                                    isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['購入有効期間'] ? '' : '#ffffff',
                                'min-height': '37px'
                            }"
                        >
                            {{ dataObject.purchase_validity_period.data }}
                        </div>
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_validity_period_first)"
                            v-model="dataObject.purchase_validity_period.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('purchase_validity_period', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_validity_period_secondary)"
                            v-model="dataObject.purchase_validity_period.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('purchase_validity_period', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['対象商品']">
                    <td class="bg-color6" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_11(dataObject)['対象商品']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        shipping: dataObject.shipping
                                    })
                                "
                            />
                            対象商品
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab11-textarea-12"
                            :model.sync="dataObject.shipping.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['対象商品']"
                            :config="inputConfig.shipping"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.shipping_first)"
                            v-model="dataObject.shipping.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('shipping', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.shipping_secondary)"
                            v-model="dataObject.shipping.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('shipping', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['購入条件']">
                    <td class="bg-color6" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_11(dataObject)['購入条件']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        purchase_conditions: dataObject.purchase_conditions
                                    })
                                "
                            />
                            購入条件
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab11-textarea-13"
                            :model.sync="dataObject.purchase_conditions.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['購入条件']"
                            :config="inputConfig.purchase_conditions"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_conditions_first)"
                            v-model="dataObject.purchase_conditions.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('purchase_conditions', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_conditions_secondary)"
                            v-model="dataObject.purchase_conditions.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('purchase_conditions', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['購入店舗・流通']">
                    <td class="bg-color6" colspan="2">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_11(dataObject)['購入店舗・流通']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        purchase_store_or_distribution: dataObject.purchase_store_or_distribution
                                    })
                                "
                            />
                            購入店舗・流通
                        </div>
                    </td>
                    <td colspan="2">
                        <CommonMultiselect
                            v-model="dataObject.purchase_store_or_distribution.data.select_data"
                            :options.sync="option.purchase_store_or_distribution"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['購入店舗・流通']"
                        />
                    </td>
                    <td colspan="3">
                        <TextareaComponent
                            id="tab11-textarea-14"
                            :model.sync="dataObject.purchase_store_or_distribution.data.input_data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['購入店舗・流通']"
                            :config="inputConfig.purchase_store_or_distribution"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_store_or_distribution_first)"
                            v-model="dataObject.purchase_store_or_distribution.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('purchase_store_or_distribution', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_store_or_distribution_secondary)"
                            v-model="dataObject.purchase_store_or_distribution.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('purchase_store_or_distribution', 'secondary')"
                        />
                    </td>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['＜購買チェック＞その他']">
                    <tr>
                        <td class="bg-color6" colspan="2" rowspan="2">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_11(dataObject)['＜購買チェック＞その他']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            purchase_info_other: dataObject.purchase_info_other,
                                            purchase_info_other_detail: dataObject.purchase_info_other_detail
                                        })
                                    "
                                />
                                その他
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.purchase_info_other.data"
                                :options.sync="option.purchase_info_other"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜購買チェック＞その他']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_info_other_first)"
                                v-model="dataObject.purchase_info_other.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('purchase_info_other', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_info_other_secondary)"
                                v-model="dataObject.purchase_info_other.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('purchase_info_other', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab11-textarea-15"
                                :model.sync="dataObject.purchase_info_other_detail.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['＜購買チェック＞その他']"
                                :config="inputConfig.purchase_info_other_detail"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_info_other_detail_first)"
                                v-model="dataObject.purchase_info_other_detail.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('purchase_info_other_detail', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.purchase_info_other_detail_secondary)"
                                v-model="dataObject.purchase_info_other_detail.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('purchase_info_other_detail', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_11(dataObject, isPreview)['フリーブロックその他先']">
                    <td class="bg-color6" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_11(dataObject)['フリーブロックその他先']"
                            @change="toggleCommonSwitch($event, { free_block_other: dataObject.free_block_other })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_other.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['フリーブロックその他先']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['フリーブロックその他先'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div v-if="isNotCheckBoxPartner || isDisabled" class="box--text__disabled" v-html="dataObject.free_block_other.data"></div>
                        <Editor
                            v-else
                            :id="`editor-${idTab}`"
                            :model.sync="dataObject.free_block_other.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_11(dataObject)['フリーブロックその他先'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CommonMultiselect from './CommonMultiselect.vue';
import Editor from '@/components/Editor/main.vue';
import editorDelayMixin from '@/mixins/editorDelayMixin';
import CommonCheckbox from './CommonCheckbox.vue';
import TextareaComponent from '@/components/Textarea/main.vue';

import { InputText } from '@/components/Input';
import { STR_DATE } from '@/utils/format';
import {
    formatDateTimeJapanese,
    toggleCommonSwitch,
    isRolePartner,
    onHandleDataCheckValueForPartner,
    calculateRowspan
} from '@/views/pages/require/handlers';
import { CONFIG_TABLE_TAB_11 } from '@/views/pages/require/constant-table';
import { SWITCH_FIELD_TAB_11, configHelperOptions, CONFIG_INPUT_TAB_11, CONFIG_ROWSPAN_TAB_11 } from '@/views/pages/require/const-field-tab';

export default {
    name: 'Tab11Require',
    mixins: [editorDelayMixin],
    props: {
        isNotCheckBoxPartner: {
            type: Boolean,
            default: () => false
        },
        keyTab: {
            type: [String],
            default: ''
        },
        idTab: {
            type: [String, Number],
            default: ''
        },
        dataObject: {
            type: Object,
            required: false
        },
        currentUser: {
            type: Object,
            required: false
        },
        detailBeginForDocument: {
            type: Object,
            required: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        isPreview: {
            type: Boolean,
            default: false
        },
        processingFields: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        CommonMultiselect,
        CommonCheckbox,
        InputText,
        TextareaComponent,
        Editor
    },
    computed: {
        lengthHeaders() {
            return CONFIG_TABLE_TAB_11().headers.reduce((acc, col) => acc + (col.colspan || 1), 0);
        }
    },
    data() {
        return {
            customFormatDate: STR_DATE,
            option: configHelperOptions.optionTab11,
            CONFIG_ROWSPAN_TAB_11,
            isRolePartner: isRolePartner(),
            inputConfig: CONFIG_INPUT_TAB_11()
        };
    },
    methods: {
        formatDateTimeJapanese,
        CONFIG_TABLE_TAB_11,
        toggleCommonSwitch,
        SWITCH_FIELD_TAB_11,
        calculateRowspan,

        handleCheckBoxValue(fieldName, type, index) {
            const payload = onHandleDataCheckValueForPartner(this.keyTab, this.dataObject, fieldName);
            this.$emit('handleTabCheckBoxValue', { payload, fieldName, type, index });
        }
    },

    watch: {},
    mounted() {}
};
</script>
